import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const ConstruirPdfAyudaHumanitaria = (datos, Encabezado, Titulos) => {
    const pdf = new jsPDF('p', 'pt', [600, 500]);
    pdf.setFontSize(7).setFont("helvetica", 'normal');
    pdf.text("??", 10,20,);
    if(datos){
        const img = new Image()
        img.src = '/dist/img/alcaldialogo.jpg';
        pdf.addImage(img, 'png', 400, 30, 70, 40);
        pdf.setFontSize(9).setFont("helvetica", 'bold')
        const titulo1 = Titulos.find(titulo => titulo.camNombrecampo === "titulo1").camValorcampo;
        const pageWidth = pdf.internal.pageSize.getWidth();
        const textWidth = pdf.getTextWidth(titulo1);
        const textX = (pageWidth - textWidth) / 2;
        pdf.text(titulo1, textX, 80);
        pdf.setFontSize(9).setFont("helvetica", 'bold')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "titulo2").camValorcampo, 200,100,);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "fecha").camValorcampo, 25,140,);
        pdf.setFontSize(8).setFont("helvetica", 'bold')
        pdf.text(Encabezado.fecha.split('T')[0], 70,140,);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "documento").camValorcampo, 150,140);
        pdf.setFontSize(8).setFont("helvetica", 'bold')
        pdf.text(Encabezado.idpersona, 270,140,);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "nombre").camValorcampo, 25,152);
        pdf.setFontSize(8).setFont("helvetica", 'bold')
        pdf.text(Encabezado.nombre, 150,152);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        const componente = Titulos.find(titulo => titulo.camNombrecampo === "componente").camValorcampo;
        const componentenombre = Titulos.find(titulo => titulo.camNombrecampo === "componentenombre").camValorcampo;
        pdf.text(`${componente}: ${componentenombre}`, 25,170);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "entrega").camValorcampo, 25,182,);
        pdf.setFontSize(8).setFont("helvetica", 'bold')
        pdf.text(Encabezado.entrega, 90,182);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "textocontratos").camValorcampo, 25,205, {maxWidth: 420, align: 'justify'});
        const data = [["","","",""]];
        const Total = 0;
        for (const element of datos) {
            data.push([element.cantidad.toString(), element.ayuda, `$ ${element.valor.toString()}`, `$ ${element.valor.toString()}`]);
        }
        data.splice(0, 1);

        const RowsCount = data.length;
        let PositionTables = 240;

        autoTable(pdf, {
            startY: PositionTables,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            headStyles: {
            halign: 'center',
            fillColor: [255, 255, 255],
            lineColor: [0,0,0],
            textColor: [0, 0, 0],
            lineWidth: 0.5,
            fontSize: 8,
            cellPadding: 1
            },
            columnStyles: {
            0: { halign: 'center', cellWidth: 70, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            1: { halign: 'left', cellWidth: 205, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            2: { halign: 'right', cellWidth: 80, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            3: { halign: 'right', cellWidth: 80, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1}
            },
            head: [['Cantidad', 'Descripción', 'Valor unitario', 'Valor']],
            body: data,
        });
        PositionTables = PositionTables + ((RowsCount+1)*11.1);
        const dataTotal = [["Total: ", `$ ${Encabezado.valor.toString()}`]];
        autoTable(pdf, {
            startY: PositionTables,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            columnStyles: {
            0: { halign: 'right', cellWidth: 355, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            1: { halign: 'right', cellWidth: 80, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1}
            },
            body: dataTotal,
        });
        PositionTables = PositionTables + 50;
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text("RECIBE ", 25,PositionTables);
        PositionTables = PositionTables + 5;
        let dataFirma = [["C.C. Nro. ","Huella índice derecho"]];
        autoTable(pdf, {
            startY: PositionTables,
            tableWidth: 270,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            columnStyles: {
            0: { valign: 'bottom', halign: 'left', cellWidth: 210, minCellHeight: 50, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            1: { valign: 'bottom', halign: 'center', cellWidth: 60, minCellHeight: 50, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 5, cellPadding: 1}
            },
            body: dataFirma,
        });
        PositionTables = PositionTables + 80;
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text("ENTREGA ", 25,PositionTables);
        PositionTables = PositionTables + 5;
        dataFirma = [["C.C. Nro. "]];
        autoTable(pdf, {
            startY: PositionTables,
            tableWidth: 270,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            columnStyles: {
            0: { valign: 'bottom', halign: 'left', cellWidth: 270, minCellHeight: 40, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1}

            },
            body: dataFirma,
        });
        PositionTables = PositionTables + 40;
        dataFirma = [["Nombre",""]];
        autoTable(pdf, {
            startY: PositionTables,
            tableWidth: 270,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            columnStyles: {
            0: { valign: 'bottom', halign: 'left', cellWidth: 60, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            1: { valign: 'bottom', halign: 'center', cellWidth: 210, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 5, cellPadding: 1}
            },
            body: dataFirma,
        });
        PositionTables = PositionTables + 22;
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "operador").camValorcampo, 25,PositionTables);
        
    }
    const pdfBlob  = pdf.output('blob');
    const fileURL = URL.createObjectURL(pdfBlob); 
    return fileURL;
};

export default ConstruirPdfAyudaHumanitaria;